export default __webpack_public_path__ + "static/media/Group3541.56ed1e18.svg";